import React from 'react'
import ListCartsTable from './ListCartsTable'
import Card from 'antd/lib/card/Card'

const CartManagementPage = () => {
  return (
    <Card>
      <ListCartsTable />
    </Card>
  )
}

export default CartManagementPage
